export const actionValidatorJSON: {
  Action: string;
  Identifier: string;
  landlord_admin?: "X";
  landlord?: "X";
  tenant_admin?: "X";
  tenant?: "X";
  operation_manager?: "X";
  entrepreneur_admin?: "X";
  entrepreneur?: "X";
  current_user?: "X";
}[] = [
  {
    Action: "Opprette eiendom",
    Identifier: "property_create",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Eiendomsinnstillinger",
    Identifier: "property_show_settings",
    landlord_admin: "X",
  },
  {
    Action: "Legge til leietaker-enhet",
    Identifier: "property_create_tenant_unit",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Invitere utleier",
    Identifier: "property_invite_landlord",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Invitere leietaker",
    Identifier: "property_invite_tenant",
    landlord_admin: "X",
    landlord: "X",
    tenant_admin: "X",
  },
  {
    Action: "Endre synlighet på utleier",
    Identifier: "property_edit_visibility_landlord",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre synlighet på leverandør",
    Identifier: "property_edit_visibility_contractor",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
    entrepreneur_admin: "X",
  },
  {
    Action: "Endre synlighet på leietaker",
    Identifier: "property_edit_visibility_tenant",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
    tenant_admin: "X",
  },
  {
    Action: "Endre rolletittel på utleier",
    Identifier: "property_edit_role_title_landlord",
    current_user: "X",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre rolletittel på leverandør",
    Identifier: "property_edit_role_title_contractor",
    current_user: "X",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
    entrepreneur_admin: "X",
  },
  {
    Action: "Endre rolletittel på leietaker",
    Identifier: "property_edit_role_title_tenant",
    current_user: "X",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
    tenant_admin: "X",
  },
  {
    Action: "Gjøre til/fjerne driftsansvarlig",
    Identifier: "property_administrate_operation_manager",
    landlord_admin: "X",
  },
  {
    Action: "Gjøre til superbruker",
    Identifier: "property_assign_admin",
    landlord_admin: "X",
  },
  {
    Action: "Gjøre leietaker til superbruker",
    Identifier: "property_assign_tenant_admin",
    landlord_admin: "X",
    tenant_admin: "X",
  },
  {
    Action: "Fjerne som superbruker",
    Identifier: "property_remove_admin",
    current_user: "X",
    landlord_admin: "X",
  },
  {
    Action: "Fjerne leietaker som superbruker",
    Identifier: "property_remove_tenant_admin",
    current_user: "X",
    landlord_admin: "X",
    tenant_admin: "X",
  },
  {
    Action: "Fjerne utleier superbruker fra eiendom",
    Identifier: "property_kick_landlord_admin",
    current_user: "X",
    landlord_admin: "X",
  },
  {
    Action: "Fjerne utleier fra eiendom",
    Identifier: "property_kick_landlord",
    current_user: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Fjerne leietaker fra eiendom",
    Identifier: "property_kick_tenant",
    current_user: "X",
    landlord_admin: "X",
    tenant_admin: "X",
  },
  {
    Action: "Leietakerinnstillinger",
    Identifier: "property_show_tenant_settings",
    landlord_admin: "X",
  },
  {
    Action: "Skrive innlegg på eiendom",
    Identifier: "property_create_post",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Arkiver eiendom",
    Identifier: "property_archive",
    landlord_admin: "X",
  },
  {
    Action: "Arkiver leietakerfil",
    Identifier: "archive_tenant_unit_file",
    landlord_admin: "X",
  },
  {
    Action: "Opprette avvik",
    Identifier: "deviation_create",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
    tenant_admin: "X",
    tenant: "X",
    entrepreneur_admin: "X",
    entrepreneur: "X",
  },
  {
    Action: "Arkivere avvik",
    Identifier: "deviation_archive",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Slette avvik",
    Identifier: "deviation_delete",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre avvik tittel og beskrivelse",
    Identifier: "deviation_edit_general_settings",
    current_user: "X",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre avvik etasjer",
    Identifier: "deviation_edit_floors",
    current_user: "X",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre avvik stedsbeskrivelse",
    Identifier: "deviation_edit_place",
    current_user: "X",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre avvik synlighet",
    Identifier: "deviation_edit_visibility",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre avvik startdato",
    Identifier: "deviation_edit_start",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre avvik frist",
    Identifier: "deviation_edit_deadline",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre avvik koblinger",
    Identifier: "task_edit_relatives",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre avvik leietaker",
    Identifier: "task_edit_tenant_units",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre avviksprioritering",
    Identifier: "deviation_change_priority",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre avvik kategori",
    Identifier: "deviation_change_category",
    current_user: "X",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre fakturamottaker",
    Identifier: "deviation_change_invoiceReceiver",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Tildele leverandører til avvik",
    Identifier: "deviation_assign_contractors",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Administrere ansvarlige og utførende på avvik",
    Identifier: "deviation_assign_responsibles_executors",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
    entrepreneur_admin: "X",
    entrepreneur: "X",
  },
  {
    Action: "Legge til kommentar på avvik",
    Identifier: "deviation_add_comment",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
    tenant_admin: "X",
    tenant: "X",
    entrepreneur_admin: "X",
    entrepreneur: "X",
  },
  {
    Action: "Administrere timeregistreringer",
    Identifier: "deviation_administrate_time_entries",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
    entrepreneur_admin: "X",
    entrepreneur: "X",
  },
  {
    Action: "Administrere eksterne linker på avvik",
    Identifier: "deviation_administrate_links",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre status på avvik",
    Identifier: "deviation_change_status",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
    entrepreneur_admin: "X",
    entrepreneur: "X",
  },
  {
    Action: "Opprette underoppgaver",
    Identifier: "deviation_subtask_create",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
    entrepreneur_admin: "X",
    entrepreneur: "X",
  },
  {
    Action: "Administrere ansvarlige på underoppgaver",
    Identifier: "subtask_administrate_responsible",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
    entrepreneur_admin: "X",
    entrepreneur: "X",
  },
  {
    Action: "Markere underoppgaver som utført",
    Identifier: "subtask_mark_completed",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Velge hvem som faktureres på underoppgaver",
    Identifier: "subtask_select_invoiced_to",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Se og tracke tid på underoppgaver",
    Identifier: "subtask_time_tracking",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Se og laste opp faktura på underoppgaver",
    Identifier: "subtask_invoices",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Endre innstillinger for underoppgaver",
    Identifier: "subtask_administrate_settings",
    operation_manager: "X",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Opprette rapporter",
    Identifier: "report_create",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Svare på rapporter",
    Identifier: "report_answer",
    tenant_admin: "X",
    tenant: "X",
  },
  {
    Action: "Opprette leverandørgrupper",
    Identifier: "contractors_create",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Leverandørgruppe innstillinger",
    Identifier: "contractors_show_settings",
    landlord_admin: "X",
    entrepreneur_admin: "X",
    entrepreneur: "X",
  },
  {
    Action: "Fjerne eiendom fra leverandørgruppe",
    Identifier: "contractors_remove_property",
    landlord_admin: "X",
    landlord: "X",
    entrepreneur_admin: "X",
  },
  {
    Action: "Gi leverandørgrupper tilgang til flere eiendommer",
    Identifier: "contractors_add_property",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Legge til entreprenører til leverandørgrupper",
    Identifier: "contractors_add_entrepreneur",
    landlord_admin: "X",
    landlord: "X",
    entrepreneur_admin: "X",
  },
  {
    Action: "Endre entreprenør superbruker status",
    Identifier: "contractors_edit_admin",
    landlord_admin: "X",
    entrepreneur_admin: "X",
  },
  {
    Action: "Fjerne entreprenør fra leverandørgruppe",
    Identifier: "contractors_remove_entrepreneur",
    current_user: "X",
    landlord_admin: "X",
    landlord: "X",
    entrepreneur_admin: "X",
  },
  {
    Action: "Se entreprenør-filer",
    Identifier: "contractors_show_files",
    landlord_admin: "X",
    landlord: "X",
    entrepreneur_admin: "X",
    entrepreneur: "X",
  },
  {
    Action: "Se Administrer medlemmer",
    Identifier: "account_show_administrate_members",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Se Leverandørgrupper på Min Profil",
    Identifier: "account_show_contractors",
    landlord_admin: "X",
    landlord: "X",
    entrepreneur_admin: "X",
    entrepreneur: "X",
  },
  {
    Action: "Administrere låser",
    Identifier: "locks_administrate",
    landlord_admin: "X",
  },
  {
    Action: "Tilgang til userspage",
    Identifier: "userspage_access",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Redigere bruker sitt navn",
    Identifier: "user_update_name",
    landlord_admin: "X",
  },
  {
    Action: "Redigere bruker sin telefon",
    Identifier: "user_update_phone",
    landlord_admin: "X",
  },
  {
    Action: "Redigere bruker sin epost",
    Identifier: "user_update_email",
    landlord_admin: "X",
  },
  {
    Action: "Tilgang til to-do's",
    Identifier: "activities_access",
    landlord_admin: "X",
    landlord: "X",
  },
  {
    Action: "Access to AI-inbox",
    Identifier: "ai_inbox_access",
    landlord_admin: "X",
    landlord: "X",
  },
] as const;
